<h3 id="header" class="ui primary header" style="text-transform: uppercase">
  {{ modal.context.title.replaceAll("_", " ") }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div class="ui basic segment" *ngIf="success || error">
      <div class="ui success message" *ngIf="success">
        <i (click)="close()" class="close icon"></i>
        {{ success }}
      </div>
      <div class="ui warning message" *ngIf="error">
        <i (click)="close()" class="close icon"></i>
        {{ error | json }}
      </div>
    </div>
    <div class="ui form" [formGroup]="workForm">
      <div class="field">
        <label class="required">Description</label>
        <textarea rows="2" formControlName="firstDescription"></textarea>
      </div>
      <div class="field" [ngClass]="displayFieldCss('active')">
        <label class="required">Active</label>
        <select formControlName="active">
          <option *ngFor="let option of activeOptions" [value]="option.optionId">
            {{ option.optionName }}
          </option>
        </select>
        <app-field-error-display [displayError]="isFieldValid('active')" errorMsg="Please enter name">
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('workFlowType')">
        <label class="required">Workflow Type</label>
        <input [readonly]="true" formControlName="workFlowType" [(ngModel)]="selectedWorkflowTypeId" type="text" />
        <!-- <select formControlName="workFlowType">
                    <option *ngFor="let type of workFlowTypeList" [value]="type.optionId" disabled>{{type.optionName}}</option>
                </select> -->
        <app-field-error-display [displayError]="isFieldValid('workFlowType')" errorMsg="Please enter name">
        </app-field-error-display>
      </div>
      <div class="field">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="20px" class="link">
            <div class="equipment-id">
              <h2 style="font-size: 20px; font-weight: 400" class="ui primary header">
                Work Flow Groups
              </h2>
            </div>
          </div>
          <div fxLayout="row" fxLayoutGap="15px">
            <button (click)="createWorkFlowGroup()" class="ui primary icon button" style="
                border-radius: 99999px;
                margin-top: 5px;
                background-color: #f0f1f8;
              ">
              <img src="assets/icons/addition.svg" style="height: 15px; width: 15px" />
            </button>
          </div>
        </div>
      </div>
      <div class="field">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="ui segment"
          *ngFor="let group of workGroupsList; index as i">
          <div>
            <div class="ui text">
              {{ group.name }}
            </div>
          </div>
          <div>
            <button (click)="editWorkFlowGroup(i)" class="circular ui icon button" style="margin-right: 10px">
              <img src="assets/icons/edit.svg" />
            </button>
            <button (click)="removeWorkFlowGroup(i)" class="circular ui icon button" style="margin-right: 10px">
              <img src="assets/icons/delete.svg" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="actions">
    <button class="ui bg-none color-primary button" (click)="modal.deny(undefined)" appMargin marginR="10px"
      paddingX="15px">
      Cancel
    </button>
    <button class="ui primary button" [ngClass]="{ loading: pending }"
      [disabled]="!workForm.valid || workGroupsList.length < 1" (click)="save()" autofocus>
      Create
    </button>
  </div>
</div>
